import { createTheme } from "@mui/material/styles";

// Public site theme - only used for notifications & spinners; the site itself is styled in css/site.css
const theme = createTheme({
  palette: {
    primary: {
      main: "#A07B4F",
      contrastText: "#fff",
    },
    secondary: {
      main: "#C0AA8F",
      contrastText: "#2D2D2C",
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#2D2D2C",
    },
  },
  typography: {
    fontFamily: "\"Helvetica Neue\", \"Inter\", Arial, sans-serif",
  },
});

export default theme;
